import { render, staticRenderFns } from "./PatentBatchCreateForm.vue?vue&type=template&id=f309b052&scoped=true&"
import script from "./PatentBatchCreateForm.vue?vue&type=script&lang=ts&"
export * from "./PatentBatchCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f309b052",
  null
  
)

export default component.exports